module.exports = __webpack_public_path__ + "static/media/Mailing-Clergy-SALVATION.c78f4465.docx";